import type { PrivilegesApiResponse } from '@app/types/profile/interfaces'

import { useProfileStore } from '@stores/profile'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

export const usePrivilegesApi = async (): Promise<string[] | null> => {
  const { $axios } = useNuxtApp()
  const profileStore = useProfileStore()

  const url = useAdminRoutes('admin.privileges')
  if (!url) {
    profileStore.setPrivileges(null)
    return null
  }

  try {
    const { data } = await $axios.get<PrivilegesApiResponse>(url)
    profileStore.setPrivileges(data.data.privileges)
    return data.data.privileges
  } catch (err: unknown) {
    console.error(err)
    return null
  }
}
